import { logEvent } from '@/utils/analytics';
import styled, { css } from 'styled-components';
import Link, { type LinkProps } from 'next/link';
import { typography, colors } from '@zopauk/react-components';
import Events from '@/utils/amplitudeEvents.json' with { type: 'json' };

const linkStyle = css`
  background-color: transparent;
  font-size: inherit;
  font-family: ${typography.primary};
  font-weight: ${typography.weights.semiBold};
  line-height: inherit;
  color: ${colors.actionPlain};
  cursor: pointer;
  text-decoration: underline;
  user-select: auto;
  appearance: none;
  padding: 0;
  border: none;

  &:hover,
  &:active {
    color: ${colors.actionDark};

    svg path {
      fill: ${colors.actionDark};
    }
  }
`;

const StyledA = styled(Link)`
  ${linkStyle}

  &.no-decoration {
    text-decoration: none;
  }

  &.has-icon:hover {
    color: inherit;
  }

  &.has-icon:hover svg path,
  &.has-icon:active svg path {
    fill: currentcolor;
  }
`;

export const FakeLink = styled.span`
  ${linkStyle}
`;

export type TextLinkProps = {
  logEventProperties?: Record<string, unknown>;
  'data-automation'?: string;
  children: React.ReactNode;
  className?: string;
  target?: '_blank';
  scroll?: boolean;
  title?: string;
  rel?: string;
} & LinkProps;

export const TextLink = ({
  logEventProperties = {},
  scroll = true,
  className,
  children,
  replace,
  target,
  title,
  href,
  rel,
  ...rest
}: TextLinkProps) => (
  <StyledA
    onClick={(event) => {
      if (rest.onClick) {
        rest.onClick(event);
      }

      logEvent(Events.LINK_CLICK, {
        currentPage: window.location.href,
        text: children?.toString(),
        type: 'text-link',
        target,
        href,
        ...logEventProperties,
      });
    }}
    data-automation={rest?.['data-automation']}
    className={className}
    replace={replace}
    target={target}
    scroll={scroll}
    title={title}
    href={href}
    rel={rel}
  >
    {children}
  </StyledA>
);
